export var DATA_TYPES = ['String', 'Number', 'Datetime', 'List', 'Boolean', 'Geo'];